import { Component, OnInit } from '@angular/core';
import { PrizeForPrecisionService } from '../../services/prize-for-precision.service';
import { mergeMap, combineLatest, map, tap } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { BehaviorSubject, of, Observable } from 'rxjs';
import { PriceForPrecisionAthlete } from '../../classes/prize-for-precision';
import { RankSortingTypeEnum } from 'world-archery-lib';


@Component({
  selector: 'app-price-for-precision-list',
  templateUrl: './price-for-precision-list.component.html',
  styleUrls: ['./price-for-precision-list.component.scss']
})
export class PriceForPrecisionListComponent implements OnInit {
  athletes: Array<PriceForPrecisionAthlete> = [];
  loading: boolean;
  reload: BehaviorSubject<boolean> = new BehaviorSubject(false);
  pagination: {
    totalResults: number,
    resultsPerPage: number,
    page: number
  } = {} as any;
  constructor(
    public filter_service: PrizeForPrecisionService,
    private http: HttpClient) {

  }

  ngOnInit() {
    this.getDataStream().subscribe(next => {
      this.athletes = next;
      this.loading = false;
    });

  }
  getDataStream(): Observable<Array<PriceForPrecisionAthlete>> {
    return this.filter_service.generateDefaultValues().pipe(
      combineLatest(this.reload.asObservable()),
      map(([a, b]) => a),
      mergeMap((values: any) => {
        if (values === undefined) {
          return of([]);
        }
        this.loading = true;
        //Always fixed to this number  https://app.asana.com/0/44511835353728/1116326924610580
        const params = {
          Year: values.year,
          CatCode: values.catCode,
          Stage: '0', //Hardcoded for obtain all data of stages
          fText: values.text,
          content: environment.priceForPrecision.apiContentData,
          v: 3,
          RBP: (this.pagination.totalResults < this.pagination.resultsPerPage) && this.athletes.length === this.pagination.totalResults ? 10 : this.pagination.resultsPerPage + 10,
          Detailed: 1,
          SortBy: (values.sort.asc === true ? '+' : '-') + values.sort.category,

        };
        return this.http.get<{ pageInfo: any, items: Array<any> }>(environment.api_url, { params: new HttpParams({ fromObject: params as any }) })
          .pipe(tap(a => this.pagination = a.pageInfo), map(a => a.items));
      })
    );
  }

  loadMore() {
    this.loading = true;
    this.reload.next(true);
  }
  changeSort(category: string) {
    if (category === undefined) {
      this.filter_service.sort.category = undefined;
      this.filter_service.sort.asc = true;
    } else {
      if (category === this.filter_service.sort.category) {
        if (this.filter_service.sort.asc === false) {
          this.filter_service.sort.category = undefined;
        }
        this.filter_service.sort.asc = !this.filter_service.sort
          .asc;
      } else {
        this.filter_service.sort.category = category as any;
        this.filter_service.sort.asc = true;
      }
    }
    this.filter_service.modifyOrderValue(Object.assign({}, this.filter_service.sort));
  }
  rankingSort() {
    if (this.filter_service.sort.category === undefined) {
      return 'asc';
    } else {
      return 'desc';
    }
  }
  sortClass(category: string) {
    if (this.filter_service.sort.category !== category) {
      return '';
    }
    return this.filter_service.sort.asc === true ? 'asc' : 'desc';
  }
}
